import { Create, Edit } from 'react-admin';
import { TagForm, TagList } from '../tag';
import { EditToolbar } from '@components/EditToolbar';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

export const JobApplicationTagList = TagList;

export const JobApplicationTagCreate = () => (
  <Create>
    <TagForm domain="job_application" />
  </Create>
);

export const JobApplicationTagEdit = () => (
  <Edit mutationMode="pessimistic">
    <TagForm domain="job_application" toolbar={<EditToolbar />} />
  </Edit>
);

export const JobApplicationTagIcon = LocalOfferIcon;
